import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPeopleCopy: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPeopleCopy"><Path d="M17.5 6.5V2.5H2.5V17.5H6.5M17.5 6.5H6.5V17.5M17.5 6.5H21.5V21.5H19.6432H8.35682H6.5V17.5" stroke="currentColor"/><Path d="M16.5 12C16.5 13.3807 15.3807 14.5 14 14.5C12.6193 14.5 11.5 13.3807 11.5 12C11.5 10.6193 12.6193 9.5 14 9.5C15.3807 9.5 16.5 10.6193 16.5 12Z" stroke="currentColor"/><Path d="M8.41797 21.2722C9.19292 18.5001 11.3997 16.5 14.0011 16.5C16.6025 16.5 18.8094 18.5001 19.5843 21.2722" stroke="currentColor"/></CentralIconBase>;
});

export default IconPeopleCopy;
